module.exports = __webpack_public_path__ + "00c24dff538b73c3162a164f98e139ba.png";